import { PaymentMethod, PaymentMethodBillingInfoDto, PaymentMethodCardMetadata } from '@breezy/shared'
import { useCallback, useState } from 'react'
import { trpc } from '../../../hooks/trpc'

type UseCreatePaymentMethodRecordFromSubscriptionProps<
  PaymentMethodType extends PaymentMethod.CARD | PaymentMethod.ACH,
> = {
  accountGuid: string
  paymentMethod: PaymentMethodType
}

export const useCreatePaymentMethodRecordFromSubscription = <
  PaymentMethodType extends PaymentMethod.CARD | PaymentMethod.ACH,
>({
  accountGuid,
  paymentMethod,
}: UseCreatePaymentMethodRecordFromSubscriptionProps<PaymentMethodType>) => {
  const [isLoading, setIsLoading] = useState(false)

  const createPaymentMethodFromSubscriptionMutation =
    trpc.payments['payments:payment-method:create-from-payment-subscription'].useMutation()

  const createPaymentMethodRecord = useCallback(
    async (
      billingInfo: PaymentMethodBillingInfoDto,
      companyGuid: string,
      paymentSubscriptionGuid: string,
      cardMetadata: PaymentMethodCardMetadata | undefined,
    ) => {
      setIsLoading(true)
      try {
        return await createPaymentMethodFromSubscriptionMutation.mutateAsync({
          accountGuid,
          companyGuid,
          paymentSubscriptionGuid,
          paymentMethodType: paymentMethod,
          billingInfo,
          cardMetadata,
        })
      } finally {
        setIsLoading(false)
      }
    },
    [accountGuid, createPaymentMethodFromSubscriptionMutation, paymentMethod],
  )

  return { createPaymentMethodRecord, isLoading }
}
